import type { WorkflowExecution } from '@/hooks/useWorkflowExecutions';
import { DATE_GROUP_LABELS, type DateGroup } from '@/utils/date';
import { ChatRow } from './ChatRow';

export interface ChatGroupProps {
  group: DateGroup;
  executions: WorkflowExecution[];
  activeExecutionId?: string;
  onRename: (execution: WorkflowExecution) => void;
  onDelete: (executionId: string) => void;
}

/** One relative-date bucket: "Today", "Previous 7 days", and so on. */
export function ChatGroup({
  group,
  executions,
  activeExecutionId,
  onRename,
  onDelete,
}: ChatGroupProps) {
  return (
    <li>
      <h3 className="px-2 pb-0.5 pt-2.5 text-v2-eyebrow font-medium uppercase text-v2-sidebar-foreground/60">
        {DATE_GROUP_LABELS[group]}
      </h3>
      <ul className="flex flex-col gap-0.5">
        {executions.map(execution => (
          <ChatRow
            key={execution.id}
            execution={execution}
            isActive={String(execution.id) === activeExecutionId}
            onRename={() => onRename(execution)}
            onDelete={() => onDelete(String(execution.id))}
          />
        ))}
      </ul>
    </li>
  );
}
